// Externe Bibliotheken
import React from 'react';

export function seating_arrangements() {
    return (
        <>
            <div className="heading">Sitzplatzregelungen</div>
            <p>Bitte berücksichtigen Sie bei der Auswahl Ihrer Plätze die unten beschriebenen Sitzregeln:</p>
            <ul>
                <li>
                    Wir bitten unsere Passagiere mit eingeschränkter Mobilität oder Passagiere, die mit einem Rollstuhl
                    reisen, sich mindestens 48 Stunden vor Abflug mit unserem Serviceteam in Verbindung zu setzen, um
                    uns über ihre besonderen Bedürfnisse zu informieren.
                </li>
                <li>
                    Falls die Sicherheitsbestimmungen es erfordern, behalten wir uns das Recht vor, Ihnen einen anderen
                    Platz zuzuweisen. Die Reservierungsgebühr kann in einem solchen Fall nicht zurückerstattet werden.
                </li>
                <li>
                    Bitte beachten Sie, dass Passagiere mit eingeschränkter Mobilität nur Sitzplätze am Fenster (A/F)
                    vorab reservieren können. Andere Sitzplätze können abhängig vom Grad bzw. der Art der körperlichen
                    Einschränkung ggf. am Flughafen vom Check-in Personal zugeteilt werden.
                </li>
                <li>Je Sitzreihe ist nur ein Baby erlaubt.</li>
            </ul>
        </>
    );
}
